<template>
  <div class="home-layout" :class="modeClass">
    <header v-if="!$route.meta.noHeader" class="home-layout-header-row">
      <home-layout-header />
    </header>
    <div v-if="!$route.meta.noHeader" class="filter-section">
      <div v-if="viewMode === 'nft'" class="filters-group">
        <nft-type-filter-comp :selected="nftCtgy" @update:selected="changeCtgy"/>
        <nft-sort-filter-comp />
      </div>
      <div v-if="viewMode === 'cltn'" class="filters-group">
        <cltn-type-filter-comp />
        <cltn-sort-filter-comp />
      </div>
    </div>
    <section>
      <router-view />
    </section>
    <footer>
      <home-layout-footer />
    </footer>
  </div>
  <CommonFooter />
</template>

<script lang="ts">
import {computed, defineComponent} from 'vue';
import HomeLayoutHeader from '@/components/layout/home_layout/HomeLayoutHeader.vue';
import HomeLayoutFooter from '@/components/layout/home_layout/HomeLayoutFooter.vue';
import NftTypeFilterComp from '@/components/pages/home/comp/NftTypeFilterComp.vue';
import NftSortFilterComp from '@/components/pages/home/comp/NftSortFilterComp.vue';
import CltnTypeFilterComp from '@/components/pages/home/comp/CltnTypeFilterComp.vue';
import CltnSortFilterComp from '@/components/pages/home/comp/CltnSortFilterComp.vue';
import CommonFooter from '@/components/layout/CommonFooter.vue';
import {store} from '@/store';
import {useRoute} from 'vue-router';
import {useHomeListConfig, useHomeListCtgyConfig} from '@/script/homeScript';

export default defineComponent({
  name: 'HomeLayout.vue',
  components: {
    HomeLayoutHeader,
    HomeLayoutFooter,
    NftTypeFilterComp,
    NftSortFilterComp,
    CltnTypeFilterComp,
    CltnSortFilterComp,
    CommonFooter,
  },
  setup() {
    const route = useRoute()
    const modeClass = computed(() => {
      if (route.name === 'HomeView') return store.getters['status/getNftListClass']
      return 'status-able'
    })
    const {
      viewMode,
    } = useHomeListConfig()

    const {
      changeCtgy,
      nftCtgy,
    } = useHomeListCtgyConfig()
    return {
      modeClass,
      viewMode,
      nftCtgy,
      changeCtgy,
    }

  }
})
</script>
